import { render, staticRenderFns } from "./LevelsList.vue?vue&type=template&id=880d39bc&scoped=true&"
import script from "./LevelsList.vue?vue&type=script&lang=js&"
export * from "./LevelsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880d39bc",
  null
  
)

export default component.exports